import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Header from "../Header/Header";
import { isMobile } from "react-device-detect";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";

class navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    return (
      <div className="Navbar" id="header">
        {isMobile ? (
          <React.Fragment>
            <div className="MenuNavBar">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={this.handleClick}
                className="MenuButton"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                open={this.state.open}
                onClose={this.handleClose}
                className="MenuNav"
                anchorEl={this.state.anchorEl}
              >
                <MenuItem key={"1"} selected={false} onClick={this.handleClose}>
                  {"COMO COMPRAR"}
                </MenuItem>
                <MenuItem key={"2"} selected={false} onClick={this.handleClose}>
                  {"AUTOS EN STOCK"}
                </MenuItem>
                <MenuItem
                  key={"3"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"COROLLA"}
                </MenuItem>
                <MenuItem
                  key={"4"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"ETIOS"}
                </MenuItem>
                <MenuItem
                  key={"5"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"YARIS"}
                </MenuItem>
                <MenuItem
                  key={"6"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"HILUX"}
                </MenuItem>
                <MenuItem
                  key={"7"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"SW4"}
                </MenuItem>
                <MenuItem
                  key={"8"}
                  selected={false}
                  onClick={this.handleClose}
                  className="MenuItem2"
                >
                  {"RAV4"}
                </MenuItem>
                <MenuItem key={"9"} selected={false} onClick={this.handleClose}>
                  {"FAQ"}
                </MenuItem>
                <MenuItem
                  key={"10"}
                  selected={false}
                  onClick={this.handleClose}
                >
                  {"CONTACTO"}
                </MenuItem>
                ))
              </Menu>
            </div>
            <img src="/img/main-top-m.png" className="Top" id="header-top" />
          </React.Fragment>
        ) : (
          <div>
            <img src="/img/main-top-2.png" className="Top" id="header-top" />
            <div className="Video-button-container">
              <img
                src="/img/video-button.png"
                className="Video-button"
                onClick={this.props.onClick}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default navbar;
